import React from 'react';
import SiteApp from './site/SiteApp';

const App = () => <SiteApp />;

export default App;
